<template>
  <div class="quickWithdrawalBenefit">
    <span class="applydrawable">申請提領</span>
    <div class="divider"></div>
    <div class="leftSub">
      <el-form :model="applyForm" :rules='rules' ref='applyForm'>
        <el-form-item label="" prop="amount">
          <el-input v-model="applyForm.amount" autocomplete="off" placeholder="請輸入提領金額"></el-input>
          <span class="currentKind">$</span>
        </el-form-item>
        <p class="canbemade">可提領金額<span>NT$</span>{{amounts}}</p>
      </el-form>
      <div class="footer">
        <button text="button" @click="submitForm('applyForm')">
          <i v-if="isLoading" class="el-icon-loading"></i>
          <template v-else>確認提領</template>
        </button>
      </div>
      <!-- <button @click="test()">測試</button> -->
    </div>
    <div class="rightTip">
      <h3>TIPS:</h3>
      <!-- <p>1. 添加客服 Line</p> -->
      <p>1. 私訊nicee客服自己的niceeID以及提領流水（確認提領後可以看到）</p>
      <p>2. 告知客服選定的支付方式，並提供該付款方式的收款相關信息</p>
      <p>3. 信息完備後預計1~2天可到賬</p>
      <p>4. 此提領方式，僅限邀請活動期間有效 </p>
    </div>
  </div>
</template>

<script>
import { applyWithdraw } from '@/api'

export default {
  data(){
    const isAccount = (rule,value,callback) =>{
      let d = parseFloat(this.amounts)
      //輸入的數字可以是整數，可以是小數，但是不能超過2位小數
      let regEn = /^-?\d{1,4}(?:\.\d{1,2})?$/
      if (value >= 10000) {
        callback('單次提領不能超過10000')
      } else if (!regEn.test(value)) {
        callback(new Error('請輸入正確的金額格式(整數、小數位數不能超過兩位)'))
      }else if(value > d){
        callback(new Error('餘額不足'))
      }else if(value == 0){
        callback(new Error('提取金額不能為0'))
      }
      
      callback()
    }
    return {
      applyForm:{
        amount:'',
      },
      currencyKind:'',
      amounts:'',     
      rules: {
        amount: [
          { required: true, message: '請輸入提現金額', trigger: 'blur' },
          {validator: isAccount, trigger: 'blur'}
        ],
      },
      isLoading: false
    }
  },
  methods:{
    getData(){
      console.log(this.$route.query.currencyKind,this.$route.query.amounts)
      this.currencyKind = this.$route.query.currencyKind
      this.amounts = this.$route.query.amounts
    },
    submitForm(formName){
      if (this.isLoading) return
      this.$refs[formName].validate((valid) =>{
        if (valid) {
          var params ={
            "accountKind":"Cash", //個人帳戶reward   激勵帳戶Cash 要根據不同情況實時改變字段
            "amount": this.applyForm.amount, //提現金額
            "currencyKind":this.currencyKind, //貨幣類型
            "withdrawKind":"Quick"
          };
          this.isLoading = true

          applyWithdraw(params).then(res =>{
            console.log(res)
            if(res.code == 200){
              this.$router.replace({
                name: 'QuickWithdraSuccess',
                query:{
                  receiptNo:res.data.receiptNo,
                  userUuid:res.data.userUuid,
                  amount:res.data.amount,
                  currencyKind:res.data.currencyKind
                }
              })
            }
            this.isLoading = false
          }).catch(() =>{
            this.isLoading = false
          })
        } else {
          return false;
        }
      })
    },
  },
  mounted(){
    this.getData()
  }
}
</script>
<style lang="scss" scoped>
.quickWithdrawalBenefit{
  width: 1200px;
  height: 600px;
  margin: 0 auto;
  padding-top: 30px;
  padding-bottom: 60px;
  margin-top:40px;
  margin-bottom: 100px;
  background: #FFFFFF;
  .leftSub{
    margin-top: 40px;
    margin-left:40px;
    margin-right: 50px;
    float: left;
    .footer{
      button{
        width: 100px;
        height: 40px;
        background: #FA006E;
        border-radius: 4px;
        margin-top: 78px;
        font-weight: 500;
        font-size: 14px;
        line-height: 40px;
        text-align: center;
        color: #FFFFFF;
      }
    }
    & /deep/ .el-form{
      color:#333333;
      .canbemade{
        margin-top: 16px;
        font-size: 16px;
        color: #666666;
        margin-top: 38px;
        margin-right: 10px;
        // position: absolute;
        // right:0;
      }
      .el-form-item{
        position: relative;
        .el-form-item__content{
          .currentKind{
            width: 34px;
            height: 60px;
            font-size: 22px;
            text-align: center;
            line-height: 60px;
            color: #333333;
            position: absolute;
            left: 0;
            top: 0;
          }
          .el-form-item__error{
            font-size: 16px;
            line-height: 22px;
            color: #FF0D0D;
            position: absolute;
            top: 60px;
            padding-top: 6px;
          }
          .el-input{
            .el-input__inner{
              width: 500px;
              height: 60px;
              background: #F6F6F6;
              box-sizing: border-box;
              border-radius: 4px;
              font-size: 22px;
              line-height: 60px;
              color: #333333 !important;
              padding-left:25px;
              // border: 2px solid #FF0D0D;
              &::placeholder{
                font-size: 22px;
                line-height: 60px;
              }
              &:hover{
                background: #F6F6F6;
                border: 1px solid #333333;
                box-sizing: border-box;
                border-radius: 4px;
              }
            }
          }
        }
        
      }
    }
  }
  .rightTip{
    float: left;
    width: 462px;
    height:255px;
    background: #F6F6F6;
    border-radius: 4px;
    margin-top: 40px;
    padding: 20px 0 33px 20px;
    h3{
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      color: #666666;
      margin-bottom: 20px;
    }
    p{
      font-size: 14px;
      line-height: 20px;
      color: #666666;
      margin-bottom: 15px;
    }
  }
  .divider{
    width: 1200px;
    height: 2px;
    background: #F4F4F4;
    margin-top: 20PX;
  }
  .applydrawable{
    margin-left: 40px;
    font-size: 22px;
    line-height: 31px;
    color: #333333;
  }
}
</style>